import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import { Locales } from './types';

const SubmitButton: FC<{ isSubmitting: boolean; isValid: boolean; locales: Locales }> = ({
  isSubmitting,
  isValid,
  locales,
}) => {
  const disabled = !isValid || isSubmitting;

  return (
    <div className="rs-text-align_center">
      <button
        type="submit"
        id="submit"
        disabled={!isValid || isSubmitting}
        className={classnames({ disabled }, 'button red')}
      >
        {isSubmitting ? locales.disable_with : locales.submit}
      </button>
    </div>
  );
};

export default SubmitButton;
